import { render, staticRenderFns } from "./ResetPin.vue?vue&type=template&id=2b7d8a08&scoped=true&"
import script from "./ResetPin.vue?vue&type=script&lang=js&"
export * from "./ResetPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d8a08",
  null
  
)

export default component.exports